import { useTheme } from "@mui/material";
import { getNotesSectionsStyles } from "../../styles/ThemePanel";

export const SectionList = ({ sections, selectedIdSection, handleSelect }) => {
    const theme = useTheme();
    const classSection = getNotesSectionsStyles(theme);

    return (
        <>
            {sections.map((item) => (
                <div
                    key={item.ID_SECCION}
                    onClick={() => handleSelect(item.ID_SECCION, item.NOMBRE_SECCION)}
                    style={
                        selectedIdSection === item.ID_SECCION
                        ? classSection.selectedContainer
                        : classSection.itemContainer
                    }
                >
                    <div style={classSection.itemName}>
                        {item.NOMBRE_SECCION.toLowerCase()}
                    </div>
                </div>
            ))}
        </>
    );
};